export default __webpack_public_path__ + "static/media/heart-broken-solid.00273732.svg";